export const auditTagTypes = [
  // Tags for admin vs user actions
  'admin',
  'user',

  // Actions
  'view',
  'create',
  'edit',
  'delete',
  'program',

  // Tags for the different sub-systems
  'cashier',
  'order',
  'support',
  'volunteer',
  'hotel',
  'task',
  'webhook',
  'email',
  '2fa',
  'voucher',
  'oauth',
  'account',
  'login',
  'product',
  'raffle',
  'dealer',
  'device',
  'export',
  'refund',
  'option',
  'ticket',
  'registration',
  'form',
  'role',
  'convention',
  'nfc',
  'badge',
  'password',
  'access',
] as const;

export type AuditTagType = (typeof auditTagTypes)[number];
